export default "__VITE_ASSET__BxcNNoKZ__"